export const dummyStats = {
    trusted_clients: 350,
    finished_projects: 215,
    visited_conferences: 36,
    years_of_experience: 15
};